import { render, staticRenderFns } from "./HomeWishlistDE.vue?vue&type=template&id=460bccf2&scoped=true"
import script from "./HomeWishlistDE.vue?vue&type=script&lang=js"
export * from "./HomeWishlistDE.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460bccf2",
  null
  
)

export default component.exports